var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverstbl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 64,
    viewBox: "0 0 62 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 31.8514C4.5 34.7114 4.85 37.6214 5.58 40.5114C9.87 57.4414 25.69 67.3014 40.91 62.5314C53.53 58.5714 61.78 45.7914 61.78 31.8914C61.78 29.0314 61.43 26.1214 60.7 23.2314C56.4 6.29138 40.58 -3.56862 25.37 1.20138C12.74 5.16138 4.5 17.9414 4.5 31.8514Z",
    fill: "url(#paint0_linear_289_11898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6398 63.721V63.531C18.3698 62.161 8.43984 53.391 5.16984 40.511C4.43984 37.621 4.08984 34.711 4.08984 31.851C4.09984 17.951 12.3398 5.17098 24.9698 1.20098C26.5298 0.710977 28.0898 0.380977 29.6498 0.190977V0.000976562H33.1198C45.4698 0.190977 56.7698 9.32098 60.2898 23.221C61.0198 26.111 61.3698 29.021 61.3698 31.881C61.3698 45.781 53.1198 58.561 40.4998 62.521C37.9798 63.311 35.4398 63.691 32.9398 63.711H29.6398V63.721Z",
    fill: "url(#paint1_linear_289_11898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.629883 31.8514C0.629883 34.7114 0.979883 37.6214 1.70988 40.5114C5.99988 57.4414 21.8199 67.3014 37.0399 62.5314C49.6599 58.5714 57.9099 45.7914 57.9099 31.8914C57.9099 29.0314 57.5599 26.1214 56.8299 23.2314C52.5399 6.29138 36.7199 -3.56862 21.4999 1.20138C8.87988 5.17138 0.629883 17.9514 0.629883 31.8514Z",
    fill: "url(#paint2_linear_289_11898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59984 31.8409C5.59984 39.6909 8.83984 47.4409 14.9598 52.4309C25.1498 60.7509 39.4598 58.2809 46.9198 46.9209C49.8998 42.3809 51.3398 37.1109 51.3398 31.8809C51.3398 24.0309 48.0998 16.2809 41.9798 11.2809C31.7898 2.9609 17.4798 5.4309 10.0098 16.7909C7.02984 21.3309 5.58984 26.6009 5.58984 31.8309L5.59984 31.8409Z",
    fill: "url(#paint3_linear_289_11898)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7102 31.5616C6.7102 39.3016 9.91019 46.9416 15.9402 51.8716C25.9902 60.0816 40.1102 57.6416 47.4602 46.4416C50.4002 41.9616 51.8202 36.7616 51.8202 31.6016C51.8202 23.8616 48.6202 16.2116 42.5902 11.2916C32.5402 3.09155 18.4202 5.52155 11.0602 16.7316C8.1202 21.2116 6.7002 26.4116 6.7002 31.5616H6.7102Z",
    fill: "url(#paint4_linear_289_11898)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M6.01 32.126C6.01 39.866 9.21 47.506 15.24 52.436C25.29 60.646 39.41 58.206 46.76 47.006C49.7 42.526 51.12 37.326 51.12 32.166C51.12 24.426 47.92 16.776 41.89 11.856C31.84 3.656 17.72 6.086 10.36 17.296C7.42 21.776 6 26.976 6 32.126H6.01Z",
    fill: "url(#paint5_radial_289_11898)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.366 21.7126L37.1145 21.1477C36.8623 20.581 36.4828 20.1165 36.0143 19.8008C35.5458 19.485 35.0048 19.3293 34.4456 19.3491L25.7214 19.6602C25.1622 19.6801 24.6047 19.8748 24.1047 20.2249C23.6047 20.575 23.1799 21.0681 22.8731 21.6546L18.0851 30.8065C17.7782 31.3931 17.6 32.0524 17.5686 32.7182C17.5371 33.384 17.6533 34.0329 17.9057 34.5995L18.2432 35.3577L19.3743 35.2242L18.9586 34.2905C18.7423 33.805 18.6427 33.249 18.6698 32.6786C18.6968 32.1081 18.8496 31.5432 19.1127 31.0408L23.372 22.9L24.2138 24.7907L20.1155 32.6271L24.0533 41.4716L31.5225 41.2063L32.3644 43.0971L24.6037 43.3738C24.1245 43.3909 23.6608 43.2575 23.2593 42.9869C22.8578 42.7164 22.5326 42.3182 22.3165 41.8325L19.9725 36.5677L18.8415 36.7013L21.5541 42.794C21.8064 43.3607 22.1858 43.8253 22.6543 44.141C23.1228 44.4567 23.6638 44.6125 24.223 44.5926L32.9379 44.2823C33.1156 44.2759 33.294 44.2519 33.471 44.2107L23.7017 22.2684L23.9763 21.7438C24.1116 21.4849 24.2989 21.2672 24.5195 21.1125L24.5237 21.1096C24.7635 20.942 25.0327 20.8552 25.2997 20.8594L25.703 20.8671L35.4726 42.8102C35.5942 42.6432 35.7043 42.4652 35.8019 42.2785L40.5843 33.1379C40.8912 32.5514 41.0693 31.892 41.1008 31.2262C41.1323 30.5604 41.016 29.9115 40.7637 29.3449L37.966 23.0613L37.287 24.21L39.7097 29.6515C39.926 30.137 40.0257 30.6929 39.9988 31.2634C39.972 31.8339 39.8195 32.3988 39.5567 32.9016L35.2974 41.0423L34.4559 39.1524L38.5535 31.3165L34.6163 22.4736L27.1476 22.7376L26.3054 20.846L34.066 20.5703C34.545 20.5534 35.0085 20.6869 35.4098 20.9574C35.8111 21.2279 36.1361 21.6259 36.3522 22.1113L36.6861 22.8614L37.366 21.7126ZM28.6621 34.7858L22.3545 34.9109L21.3194 32.586L24.7573 26.0155L28.6621 34.7858ZM33.0007 29.1015L34.4149 29.0734L36.313 29.0358L37.3472 31.3587L33.9102 37.9287L30.0059 29.1596L33.0007 29.1015Z",
    fill: "#7E7E7E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6175 21.2695L36.3687 20.7108C36.1192 20.1503 35.7439 19.6907 35.2805 19.3785C34.8171 19.0662 34.2819 18.9121 33.7288 18.9318L25.0994 19.2394C24.5463 19.2591 23.9948 19.4517 23.5003 19.798C23.0057 20.1443 22.5856 20.632 22.2821 21.2121L17.5461 30.2646C17.2425 30.8448 17.0663 31.4969 17.0352 32.1555C17.0041 32.8141 17.1191 33.4559 17.3687 34.0164L17.7026 34.7663L18.8213 34.6342L18.4101 33.7107C18.1962 33.2305 18.0977 32.6805 18.1245 32.1163C18.1512 31.552 18.3023 30.9933 18.5625 30.4963L22.7756 22.444L23.6082 24.3142L19.5545 32.0654L23.4495 40.8138L30.8375 40.5514L31.6702 42.4216L23.9939 42.6953C23.5199 42.7122 23.0612 42.5802 22.6641 42.3126C22.267 42.045 21.9453 41.6512 21.7315 41.1708L19.413 35.9632L18.2943 36.0953L20.9774 42.1218C21.2269 42.6823 21.6023 43.1419 22.0657 43.4542C22.5291 43.7664 23.0642 43.9205 23.6173 43.9008L32.2374 43.5939C32.4133 43.5876 32.5897 43.5639 32.7648 43.523L23.1017 21.8193L23.3732 21.3004C23.5071 21.0443 23.6924 20.829 23.9106 20.676L23.9148 20.673C24.1519 20.5073 24.4182 20.4214 24.6824 20.4256L25.0812 20.4333L34.7447 42.1378C34.8649 41.9726 34.9739 41.7966 35.0704 41.6119L39.8008 32.5707C40.1043 31.9905 40.2805 31.3383 40.3116 30.6797C40.3428 30.0211 40.2278 29.3794 39.9782 28.8189L37.211 22.6036L36.5393 23.7398L38.9357 29.1221C39.1496 29.6024 39.2482 30.1523 39.2216 30.7165C39.1951 31.2808 39.0443 31.8396 38.7843 32.3369L34.5713 40.3892L33.739 38.5197L37.792 30.769L33.8977 22.0222L26.5101 22.2833L25.6771 20.4123L33.3534 20.1396C33.8271 20.1229 34.2855 20.2549 34.6825 20.5225C35.0794 20.7901 35.4009 21.1837 35.6146 21.6639L35.945 22.4059L36.6175 21.2695ZM28.0081 34.2006L21.7692 34.3244L20.7453 32.0247L24.1458 25.5256L28.0081 34.2006ZM32.2996 28.5781L33.6985 28.5503L35.5759 28.5131L36.5989 30.8107L33.1992 37.3094L29.3374 28.6356L32.2996 28.5781Z",
    fill: "url(#paint6_linear_289_11898)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.87 31.8809C50.87 42.7709 44.41 52.7909 34.52 55.8909C22.6 59.6309 10.21 51.9109 6.84 38.6409C6.27 36.3809 5.99 34.1009 5.99 31.8509C5.99 20.9609 12.45 10.9409 22.34 7.84094C34.27 4.10094 46.66 11.8209 50.02 25.0909C50.59 27.3509 50.87 29.6309 50.87 31.8809ZM0 31.8509C0 34.6909 0.35 37.5809 1.07 40.4409C5.33 57.2509 21.03 67.0309 36.14 62.3009C48.67 58.3709 56.86 45.6809 56.86 31.8809C56.86 29.0409 56.51 26.1509 55.79 23.2809C51.53 6.48094 35.83 -3.30906 20.72 1.43094C8.19 5.36094 0 18.0509 0 31.8509Z",
    fill: "url(#paint7_linear_289_11898)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1699 23.5012C27.9299 23.2212 27.6899 22.9512 27.4399 22.7012C27.6999 22.9512 27.9399 23.2212 28.1699 23.5012Z",
    fill: "url(#paint8_linear_289_11898)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_11898",
    x1: 4.51128,
    y1: 31.8723,
    x2: 61.7405,
    y2: 31.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90908E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_289_11898",
    x1: 4.10112,
    y1: 31.8669,
    x2: 61.3304,
    y2: 31.8669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90908E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_289_11898",
    x1: 0.641158,
    y1: 31.8723,
    x2: 57.8704,
    y2: 31.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90908E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_289_11898",
    x1: 5.60677,
    y1: 31.8559,
    x2: 51.3398,
    y2: 31.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_289_11898",
    x1: 6.70142,
    y1: 31.588,
    x2: 56.6854,
    y2: 31.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90908E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_289_11898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2 31.216) rotate(90) scale(39.69 39.8147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#959595",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_289_11898",
    x1: 23.0724,
    y1: 18.8369,
    x2: 38.4354,
    y2: 40.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_289_11898",
    x1: -0.00154021,
    y1: 31.8661,
    x2: 56.8583,
    y2: 31.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_289_11898",
    x1: 27.1999,
    y1: 23.1012,
    x2: 28.4599,
    y2: 23.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverstbl);
export default __webpack_public_path__ + "static/media/silverstbl.9f9fb086c45566f21ba39f5adf483387.svg";
export { ForwardRef as ReactComponent };